import { jnjHcp, jnjHospital, jnjPatient } from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { mdiAccountCircleOutline, mdiDomain, mdiPlusBoxOutline } from "@mdi/js";

export const showIcon = (icon: string, jnjFullBranded?: boolean): string => {
    switch (icon?.toLowerCase()) {
        case "patient-center":
            return jnjFullBranded ? jnjPatient : mdiPlusBoxOutline;
        case "hospital":
            return jnjFullBranded ? jnjHospital : mdiDomain;
        default:
            return jnjFullBranded ? jnjHcp : mdiAccountCircleOutline;
    }
};
